import moment from 'moment';
import React, { useEffect, useState } from 'react';
import './TrendChart.scss';

function TrendChart(props) {
    const [headerList, setHeaderList] = useState(['', ...props.headerList]);
    const [parameterList, setParameterList] = useState(props.parameterList);

    console.log(parameterList);

    const [data, setData] = useState();

    useEffect(() => {
        if (props.headerList) setHeaderList(['', ...props.headerList]);
        setParameterList([...props.parameterList]);
        setData({ ...props.data });
    }, [props]);

    console.log(data)

    const getHtml = () => {

        let html = headerList && headerList.map((header, count) => {
            /* for rendering parameters in first column */
            console.log("header", header);
            if (count === 0) {
                return (
                    <div className="column parameters" key={header}>
                        <div className="parameter-heading param body parameters-width">PARAMETER</div>
                        {parameterList.map((param) => {

                        const cellStyle = {
                            color: param.label === "HR" ? "#67DF52" : param.label === "PR" ? "#3ADAE5"  : param.label === "SPO2" ? "#3ADAE5" : param.label === "RR" ? "#FCC331" :"#FFFFFF", 
                        };
                            return (<div className="parameter-cell  param parameters-width" key={param.label} style={cellStyle}>{param.label}</div>)
                        })}
                    </div>
                );
            } else {
                /** rendering data from the data array **/
                let col = (
                    data && data.data &&
                    data.data.filter(
                        (obj) => moment(obj.time).isSame(header)
                    )[0]
                ) || null;
                return (
                    <div className="column" key={header}>
                        <div className=" timestamp heading param">{moment(header).format("HH:mm")}</div>
                        {parameterList.map((param) => {
                            return (
                                <div className="cell" key={param.name}>
                                    {col ? col[param.name] : ""}
                                </div>);
                        })}
                    </div>
                );
            }
        });

        return html;
    }
    return (
        <div className='trend-table'>
            {getHtml()}
        </div>
    );
}

export default TrendChart;




